import ImageLoader from './imageLoader.ui';

export default ImageLoader;
